import { render, staticRenderFns } from "./AmgdHighscoreComponent.vue?vue&type=template&id=1d22be7e&"
import script from "./AmgdHighscoreComponent.vue?vue&type=script&lang=ts&"
export * from "./AmgdHighscoreComponent.vue?vue&type=script&lang=ts&"
import style0 from "./AmgdHighscoreComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports